import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomSelect from '../Utilities/CustomSelect'
import { AccountantSheetVM } from '../../Structure/ViewModels/Accountant/AccountantSheetVM'
import Search from '../Utilities/Search'
import CustomImageUpload from '../Utilities/CustomImageUpload'
import { bePath, mainPath } from '../../Structure/Constants/MainPath'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods'

const AccountantsSheet = () => {
    const [vm , setVm] = useState<{viewModel:AccountantSheetVM}>({viewModel:new AccountantSheetVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getUsers()
    },[])
    useEffect(()=>{control.getData()},[control.Users])

    const [from,setFrom] = useState('')
    const [to,setTo] = useState('')

    useEffect(() => {
      const handleScroll = () => {
          const elementCourses = scrollableRefCourses.current;
          if (elementCourses && elementCourses.scrollTop + elementCourses.clientHeight >= elementCourses.scrollHeight) {
              control.addData()
          }
      };
  
      const elementCourses = scrollableRefCourses.current;
      if (elementCourses) {
          elementCourses.addEventListener('scroll', handleScroll);
      }
  
      return () => {
          if (elementCourses) {
              elementCourses.removeEventListener('scroll', handleScroll);
          }
      };
  });

  const scrollableRefCourses = useRef<HTMLDivElement | null>(null);

  useEffect(()=>{
    if(control.Refresh){
        control.getData()
    }
  },[control.Refresh])

  var clearImg:()=>void 

  return (
    <Container>
        <Row className='py-3'>
            <Col className='p-2 px-5' md={6}>
                <div className='d-flex justify-content-around w-100 my-auto'>
                    <h5 className='w-100'>القيمة</h5>
                    <div className='w-100'>
                        <input type="text" className='input-field w-100' value={control.InputData.value} onChange={a=>control.Value = a.target.value} />
                    </div>
                </div>
            </Col>
            <Col className='p-2 px-5' md={6}>
                <div className='d-flex justify-content-around w-100 my-auto'>
                    <h5 className='w-100'>صادر/وارد</h5>
                    <div className='w-100'>
                        <CustomSelect list={[{label:'صادر', value:'outgoing'},{label:'وارد' , value:'income'}]} clearable={false} selected={control.InputData.direction} onSelect={a=>control.Direction =a} />
                    </div>
                </div>
            </Col>
            <Col className='p-2 px-5' md={6}>
                <div className='d-flex justify-content-around w-100 my-auto'>
                    <h5 className='w-100'>بيان</h5>
                    <div className='w-100'>
                        <textarea  className='input-field w-100' value = {control.InputData.notes} onChange={a=>control.Notes=a.target.value} />
                    </div>
                </div>
            </Col>
            <Col className='p-2 my-auto  px-5' md={6}>
                <div className='d-flex justify-content-around w-100 my-auto' style={{ maxHeight:'70px' }}>
                    <h5 className='w-100'>
                        صورة الفاتورة
                    </h5>
                    <div className="input-file d-flex justify-content-around w-100 h-100 my-auto position-relative">
                        <CustomImageUpload clear={a=>control.ClearImg=a} onSelect={a=>control.Img=a}/>
                    </div>
                </div>
            </Col>
            <Col className='p-5'>
                <div className='d-flex w-100 h-100'>
                    <div className='w-100 d-flex justify-content-center h-100'>
                        <button className='button-II btn-cl-I m-auto px-5 py-2' onClick={()=>control.send()}>اضافة</button>
                    </div>
                </div>
            </Col>
        </Row>
        <Row className='p-3 border'>
            <div className='d-flex py-2'>
                <div className='p-2 my-auto'>
                  <CustomSelect 
                        clearable
                        list={[{label:'صادر', value:'outgoing'},{label:'وارد' , value:'income'}]} 
                        onSelect={a=>{control.Type=a; }}
                    />
                </div>
                <div className='p-2 my-auto'>
                  <CustomSelect 
                        clearable
                        list={control.Users.map(a=>({label:a.name,value:a.id}))} 
                        onSelect={a=>{control.SelectedUser =a }}
                    />
                </div>
                <div className='p-2 my-auto'>
                    <input type="date" className='input-field' value={from} onChange={a=>setFrom(a.target.value)} />
                </div>
                <div className='p-2 my-auto'>
                    <input type="date" className='input-field'  value={to} onChange={a=>setTo(a.target.value)} />
                </div>
                <div className='p-2 my-auto'>
                  <input type="text" className='input-field my-auto' value={control.Search} onChange={a=>control.Search=a.target.value} />
                </div>
                <div className='p-2 my-auto'>
                    <button className='button-II btn-cl-I px-5 py-2' onClick={()=>{ control.From = from ; control.To = to ; control.searchData() }}>بحث</button>
                </div>
            </div>
            <div className='d-flex flex-wrap justify-content-center pt-5 pb-3'>
            <div className='d-flex p-2 my-auto'>
                <h5>الصادر</h5>
                    <h5 className='px-3 text-danger'>{control.OutGoing}</h5>
                </div>
                <div className='d-flex p-2 my-auto'>
                <h5>الوارد</h5>
                    <h5 className='px-3 text-success'>{control.Income}</h5>
                </div>
                <div className='d-flex p-2 my-auto'>
                <h5>الاجمالى</h5>
                    <h5 className={`px-3 ${control.Total<0?'text-danger':'text-success'}`}>{control.Total}</h5>
                </div>
            </div>
            {control.Show(
            <div ref={scrollableRefCourses} className=' overflow-y-auto' style={{maxHeight:'500px'}}>
                <div className='d-flex p-3 overflow-x-auto'>
                    <table className='w-100 text-center' style={{minWidth:'700px'}}>
                        <tr className='txt-color-I bg-light-gray'>
                            <th>القيمة</th>
                            <th>المستخدم</th>
                            <th>صادر/وارد</th>
                            <th>بيان</th>
                            <th>تاريخ</th>
                            <th>الفاتورة</th>
                        </tr>
                        {
                            control.Data.map((item,index)=>{
                                const Img = ()=>{
                                    const type = GeneralMethods.isImageOrPdf(item.img)
                                    if(type){
                                        if(type === 'pdf')return(<td onClick={()=>window.open(`${bePath}/storage/uploads/images/accountantRecords/${item.img}`)}>مشاهدة الملف</td>)
                                        else if(type=== 'img')return(
                                            <td onClick={()=>window.open(`${bePath}/storage/uploads/images/accountantRecords/${item.img}`)}>
                                                <img style={{height:'50px' , maxWidth:'100px'}} src={`${bePath}/storage/uploads/images/accountantRecords/${item.img}`} alt="" />
                                            </td>
                                        )
                                        else return (<td></td>)
                                    } else return (<td></td>)
                                }
                                return(
                                <tr key={index}>
                                    <td>{item.value}</td>
                                    <td>{item.user.name}</td>
                                    <td>{item.direction=='income'?'وارد':'صادر'}</td>
                                    <td>{item.notes}</td>
                                    <td>{new Date(item.created_at).toLocaleString()}</td>
                                    <td>{<Img/>}</td>
                                </tr>
                            )})
                        }
                    </table>
                </div>
            </div>)}
        </Row>
    </Container>
  )
}

export default AccountantsSheet
